<div id="modal-select-organization" class="modal-select-organization" [@fadeInOut]="state">
  <div class="modal-layer-create-room"></div>
  <div class="modal-content-create-room">
    <div class="modal-header">
      <h2>{{ 'common.organizations' | translate }}</h2>

      @if (organizationService.currentOrganization) {
        <button type="button" class="close-modal-create-room" (click)="closeModal()"></button>
      }
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" (ngSubmit)="select()">
        <div class="row-field-create-room">
          <select required formControlName="organization">
            <option value="">--{{ 'common.select-organization' | translate }}--</option>
            @for (organization of organizationService.organizationList; track organization._id) {
              <option [value]="organization._id">{{ organization.name }}</option>
            }
          </select>
        </div>

        <div class="modal-footer">
          @if (organizationService.currentOrganization) {
            <button type="button" class="modal-button-cancel-confirmation" (click)="closeModal()">
              {{ 'common.cancel' | translate }}
            </button>
          }

          <button type="submit" class="modal-button-save" [disabled]="loading">
            {{ (loading ? 'common.loading' : 'common.continue') | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
